import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Box } from '@mui/material';
import { getRandomStr } from '../../../../helpers';
// import { ReactComponent as SeparatorIcon } from '../separatorIcon.svg';
import { SortableContainer, SortableElement } from '../../../_common/SortableHOC'
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const SortableHead = SortableContainer(({ children }) => {
  return (
    <TableHead>
      <TableRow>{children}</TableRow>
    </TableHead>
  );
});

const SortableCell = SortableElement(({ value }) => {
  return <>{value}</>;
});

const EnhancedTableHead = (props) => {
  const {
    order, sectorTableCols, orderBy, onRequestSort, wrapperClass, handleSortedCells, onReorderEnd, disableAddToWatchlist
    // onSelectAllClick, rowOrder, headCellsOrder, numSelected, rowCount, headCells
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
    handleSortedCells(event, property);
  };

  const getOpacity = (field) => {
    const fieldsToHide = ['ticker', 'tickername', 'sector', 'industry', 'tickers'];
    return fieldsToHide.includes(field) ? 0 : 0.5;
  };

  const getDisplay = (field) => {
    const fieldsToHide = ['ticker', 'tickername', 'sector', 'industry', 'tickers'];
    return fieldsToHide.includes(field) ? 'none' : 'inline';
  };

  return (
    <SortableHead axis="x" onSortEnd={onReorderEnd} distance={5}>
      {!disableAddToWatchlist && <TableCell padding="checkbox" sx={{ background: '#fbfbfc' }} />}
      {sectorTableCols?.map((headCell, i) => {
        const classField = headCell?.field ? headCell?.field?.replace(/[^\w\s]/gi, '') : '';
        return (
          <SortableCell
            index={i}
            disabled={headCell?.name === 'Ticker' || headCell?.name === 'Name' ? true : false}
            key={getRandomStr(3)}
            value={
              <LightTooltip describeChild key={getRandomStr(3)} title={headCell?.tooltip} arrow placement="top-start" disableInteractive>
                <TableCell
                  // key={getRandomStr(3)}
                  className={`${wrapperClass || ''} ${orderBy === headCell?.field ? `${order}-table-cell` : ''} ${classField}-th th`}
                  // align={headCell?.class === 'td-right' ? 'right' : 'left'}
                  align="left"
                  // padding={headCell?.disablePadding ? 'none' : 'normal'}
                  sortDirection={orderBy === headCell?.field ? order : false}
                  sx={{
                    // borderBottom: '2px solid #174c86 !important',
                    background: '#fbfbfc',
                    // boxShadow: 1,
                    // borderRadius: '5px',
                    color: 'inherit',
                    whiteSpace: 'nowrap',
                    padding: '4px 12px 4px 12px !important',
                    fontWeight: '600 !important',
                    '& .TableSortLabel-icon': {
                      margin: '0 !important',
                      textAlign: 'center !important'
                    },
                    // '&:hover .drag-drop': { opacity: .5, },
                    // '&.sector-table.th': { px: '0 !important', },
                    '& .MuiSvgIcon-root.drag-drop': { marginLeft: '-6px' }
                  }}
                >
                  <DragIndicatorRoundedIcon
                    className="drag-drop"
                    sx={{
                      verticalAlign: 'middle',
                      // opacity: (headCell?.field === 'ticker' || headCell?.field === 'tickername' || headCell?.field === 'sector'|| headCell?.field === 'industry'|| headCell?.field === 'tickers') ? 0 : .5, fontSize: '1.1rem', cursor: 'grab',
                      // display: (headCell?.field === 'ticker' || headCell?.field === 'tickername' || headCell?.field === 'sector'|| headCell?.field === 'industry'|| headCell?.field === 'tickers') ? 'none' : 'inline', fontSize: '1.1rem', cursor: 'grab',
                      opacity: getOpacity(headCell?.field), fontSize: '1.1rem', cursor: 'grab',
                      display: getDisplay(headCell?.field), fontSize: '1.1rem', cursor: 'grab',
                    }}
                  />
                  <TableSortLabel
                    active={orderBy === headCell?.field}
                    direction={orderBy === headCell?.field ? order : 'asc'}
                    onClick={createSortHandler(headCell?.field)}
                  >
                    <span className="mr-1">
                      {headCell?.name}
                    </span>
                    {orderBy === headCell?.field ? (
                      <Box component="span" sx={{
                        border: 0,
                        clip: 'rect(0 0 0 0)',
                        height: 1,
                        margin: -1,
                        overflow: 'hidden',
                        padding: 0,
                        position: 'absolute',
                        top: 20,
                        width: 1,
                      }}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              </LightTooltip>
            }
          />)
      })}
    </SortableHead>
  );
}

EnhancedTableHead.propTypes = {
  // classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default EnhancedTableHead;
